import { IIconProps } from './Types';

export const SortingArrowDownIcon = ({ color = '#576264', size = 16 }: IIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height="8" viewBox="0 0 16 8" fill="none">
      <path d="M0 0L8 8L16 0L0 0Z" fill={color} />
    </svg>
  );
};
